__webpack_require__.p = "https://fantasy.bestadeildin.is/";